<template>
    <div class="box_container">
        <div class="nav_bar">
            <div class="nav_left">
              <img src="~assets/img/logo_alone.png" alt />
              <span @click='$router.push("/index")'>北京师大励耘心理档案管理系统</span>
              <a class="isPhone" href="javascript:void(0)" @click='$router.push("/profile")'>{{userInfo.userName}}</a>
              <router-link to='/index'  style="margin-left:30px;font-size:15px;">首页</router-link>
            </div>
        </div>
        <router-link to='/index'  style="margin-left:30px;font-size:15px;" tag='button' class="phone_style"><i class='el-icon-arrow-right' style='color:white'></i></router-link>
    </div>
</template>
<script>
import { mapMutations } from "vuex";
import { request } from "../network/request";
export default {
    name:'NavBox',
    data(){
        return{
          userInfo:{},
            
        }
    },
    created(){
        request({
            method: "get",
            url: "/api/User/CurrentInfo",
        }).then((res) => {
            if (res.data.code == 21002) {
            this.changeLogin({ userToken: "" });
            this.$router.push("/login");
            } else if(res.data.code == 0){
            this.userInfo = res.data.content;
            this.$emit('userInfo', this.userInfo);
            }
        });
        },
        methods:{
        ...mapMutations(["changeLogin"]),
        }
    }
</script>
<style scoped>
     .nav_bar {
      height: 80px;
      width:100%;
      /* background: linear-gradient(to bottom, rgba(0, 0, 0, .2), rgba(0, 0, 0, 0)); */
      background-color:#409EFF;
      /* min-width: 1400px; */
      box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);
      position:fixed;
      top:0px;
      left:0px;
      z-index: 1000;
      border-radius: 0px 0px 8px 8px;
    }
    .nav_left {
      padding-top: 18.5px;
      padding-left: 50px;
    }
    .nav_left img {
      height: 43px;
      vertical-align: middle;
      margin-right: 10px;
      cursor: pointer;
      user-select: none;
       -webkit-user-drag: none;
    }
    .nav_left span {
      display: inline-block;
      line-height: 43px;
      vertical-align: middle;
      color: white;
      font-size: 18px;
      font-family: -apple-system, "Helvetica Neue", Arial, "PingFang SC",
        "Hiragino Sans GB", STHeiti, "Microsoft YaHei", "Microsoft JhengHei",
        "Source Han Sans SC", "Noto Sans CJK SC", "Source Han Sans CN",
        "Noto Sans SC", "Source Han Sans TC", "Noto Sans CJK TC",
        "WenQuanYi Micro Hei", SimSun, sans-serif;
      letter-spacing: 2px;
      font-weight: 500;
      user-select: none;
      -webkit-user-drag: none;
    }
    .nav_left span:hover{
      cursor: pointer;
    } 
    .nav_left > a {
      color: white;
      float: right;
      font-size:16px ;
      line-height: 43px;
      margin-right: 50px;
      user-select: none;
      -webkit-user-drag: none;
    }
    .phone_style{
      width:40px;
      height:40px;
      background-color:rgba(0, 0, 0, 0.3);
      position:fixed;
      bottom:50px;
      left:20px;
      margin-left:0px !important;
      color:#ffffff;
      font-size:14px;
      border:0px;
      border-radius: 50%;
      z-index:10000;
      display:none;
    }
    @media screen and (max-width:600px){
      .nav_left{
        padding-left:20px;
      }
      .nav_left span{
         font-size:15px;
      }
      .nav_left img{
        height:35px;
      }
      .nav_left a{
        display:none;
      }
      .phone_style{
        display: block
      }
    }
</style>

